import { defineStyleConfig } from "@chakra-ui/react";

export const linkTheme = defineStyleConfig({
	baseStyle: {
		color: "text.link.default",
		_hover: {
			color: "text.link.hover",
		},
	},
});
